import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Компонент для скролла страницы вверх при смене маршрута.
 * Должен быть размещён внутри BrowserRouter.
 * При навигации назад (POP) скролл не сбрасывается.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [pathname, navType]);

  return null;
}
